import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { GeoAreaType } from '../../entities/control-tables/geo-area-type-entity';


export class GeoAreaTypeRequest extends BaseRequest {

  geoAreaType : GeoAreaType

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.geoAreaType = new GeoAreaType()
  }
}